import React from "react";
import Paper from "@mui/material/Paper";

const AudioMessage = ({ url }) => (
 <>
    <audio controls className="d-block m-auto audio-chat">
      <source src={url} type="audio/ogg" />
    </audio>
    </>
);

export default AudioMessage;